import React from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useTranslation } from "react-i18next";
import { StepConnector, styled } from "@mui/material";

const StepIconRoot = styled("div")(() => ({
  "& .StepIcon": {
    width: 20,
    height: 20,
    backgroundColor: "#CED0D8",
    color: "#ffffff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "20px",
    textAlign: "center",
  },
  "& .StepIcon.completed": {
    backgroundColor: "#2287B8",
  },
}));

function StepIcon(props) {
  const { active, completed, icon } = props;
  const classActive = () => (completed ? "completed" : "");

  return (
    <StepIconRoot ownerState={{ active }}>
      <div className={"StepIcon " + classActive()}>{icon}</div>
    </StepIconRoot>
  );
}

const CustomStepLabel = styled(StepLabel)(({ theme }) => ({
  "& .MuiStepLabel-label": {
    color: "#CED0D8", // Cambia el color del texto
    fontFamily: "Roboto",
    fontSize: "10px",
    lineHeight: "1",
  },
  "& .Mui-active": {
    color: "#CED0D8", // Cambia el color cuando el step está activo
    fontFamily: "Roboto",
    fontSize: "10px",
    lineHeight: "1",
  },
  "& .Mui-completed": {
    color: "#2287B8!important", // Cambia el color cuando el step está completado
  },

  "@media (min-width: 768px)": {
    "& .MuiStepLabel-label": {
      fontSize: "12px",
    },
  },

  "@media (min-width: 992px)": {
    "& .MuiStepLabel-label": {
      fontSize: "14px",
    },
  },
}));

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  "&.MuiStepConnector-root": {
    maxWidth: "20px",
    minWidth: "10px",
  },
  "& .MuiStepConnector-line": {
    borderColor: "#979797", // Cambia el color de la línea del conector
    borderTopWidth: 2, // Cambia el grosor de la línea
  },
}));

const CartSteps = ({ numberStep = 0 }) => {
  const { t } = useTranslation();

  const activeStep1 = () => {
    return numberStep >= 1;
  };

  const activeStep2 = () => {
    return numberStep >= 2;
  };

  return (
    <Stepper connector={<CustomStepConnector />} sx={{marginTop: 2}}>
      <Step completed={activeStep1()}>
        <CustomStepLabel StepIconComponent={StepIcon}>{t("cart.step.1")}</CustomStepLabel>
      </Step>
      <Step completed={activeStep2()}>
        <CustomStepLabel StepIconComponent={StepIcon}>{t("cart.step.2")}</CustomStepLabel>
      </Step>
    </Stepper>
  );
};

export default CartSteps;
